// HunchMainStrip — full-width strip wrapper around HunchMainEmbed.
//
// Same content as the in-band hunch card (HunchMainEmbed in
// compact mode: top 2 parties + "Show all" toggle). Different
// container: a horizontal strip that sits in its own row, edge-to-
// edge of the band envelope, rather than as the 4th cell of a grid.
//
// The widget self-sizes via its postMessage handshake. The strip
// is just a wrapping container that gives it the full band width
// + matches the .live-band envelope on polls_open.

import HunchMainEmbed from './HunchMainEmbed';
import './HunchMainStrip.css';

export default function HunchMainStrip() {
  return (
    <div className="hunch-main-strip">
      <div className="hunch-main-strip__inner">
        <HunchMainEmbed compact />
      </div>
    </div>
  );
}
